import { render } from "./RecipientsForm.vue?vue&type=template&id=7133d877&scoped=true"
import script from "./RecipientsForm.vue?vue&type=script&lang=js"
export * from "./RecipientsForm.vue?vue&type=script&lang=js"

import "./RecipientsForm.vue?vue&type=style&index=0&id=7133d877&scoped=true&lang=css"
import "@vueform/multiselect/themes/default.css?vue&type=style&index=1&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7133d877"]])

export default __exports__